import React from 'react';

import Table, { TABLE_TYPES, TABLE_CELL_ALIGN } from 'cirrus/Table';

import { logPropTypes } from './utils';

const AuditTrailDetailsUser = props => {
  const { log } = props;

  const { userID, employee } = log;

  const tableHead = {
    hide: true,
    cells: [
      {
        key: 'prop',
        width: '16%',
      },
      {
        key: 'details',
        width: '16%',
        align: TABLE_CELL_ALIGN.RIGHT,
      },
      {
        key: 'blank',
        width: '68%',
      },
    ],
  };

  const tableBody = [
    {
      key: 'action',
      cells: [
        { content: 'User ID:', className: 'cr-text--bold' },
        { content: userID || 'N/A' },
        { content: '' },
      ],
    },
    {
      key: 'action-time',
      cells: [
        { content: 'Employee ID:', className: 'cr-text--bold' },
        { content: employee.id || 'N/A' },
        { content: '' },
      ],
    },
  ];

  return (
    <div className="cr-flex cr-width-full cr-flex-row">
      <Table
        type={TABLE_TYPES.COMPACT}
        className="cr-ph-3 cr-flex-1"
        head={tableHead}
        body={tableBody}
      />
    </div>
  );
};

AuditTrailDetailsUser.propTypes = {
  log: logPropTypes,
};

export default AuditTrailDetailsUser;
